export default __webpack_public_path__ + "static/media/schulteletters_locked_crown.d81cdbc6.svg";